import * as React from "react";
const SvgFiRrSquareG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-g_svg__a)">
      <path
        fill="#062147"
        d="M17.594 13.158c.453.691.531 1.548.207 2.292-.955 2.198-3.345 3.603-5.798 3.603-.586 0-1.176-.08-1.751-.249-2.503-.734-4.251-3.123-4.251-5.808v-1.857c0-1.66.691-3.281 1.896-4.447a5.95 5.95 0 0 1 4.317-1.689 6.08 6.08 0 0 1 4.824 2.655 1 1 0 0 1-1.656 1.122 4.08 4.08 0 0 0-3.233-1.778c-1.052-.037-2.074.365-2.861 1.127a4.22 4.22 0 0 0-1.287 3.01v1.857c0 1.804 1.158 3.403 2.815 3.889 2.011.591 4.37-.432 5.151-2.231a.41.41 0 0 0-.045-.398.56.56 0 0 0-.465-.255H12a1 1 0 0 1 0-2h3.457c.863 0 1.662.433 2.137 1.158zM24 5v14c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-g_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareG;
